
import React from "react";
import './App.css';
import Weather from './Weather';

export default function App() {
  return (
    <div className="App">
      <div className="container">
      <h1>Weather app</h1>
      <Weather value="Glasgow" />
    <footer>
      This project was coded by Natalie Kiel and is <a href="https://github.com/nkiel2511/react-weather-final" target="_blank" rel="noreferrer">open-sourced on Github</a>
      </footer>
      </div>
      </div>
  );   
}


